import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Card } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { SlideCropped } from '../../constants/SliderConstants';
import { getPictureSrcset } from '../../util/ImageUtil';
import { Slider } from '../slider/Slider';
const IMAGE_HEIGHT = 200;
const SLIDES_PER_VIEW_MOBILE = 1;
const SLIDES_PER_VIEW_TABLET = 2;
const SLIDES_PER_VIEW_DESKTOP_MIN = 3;
const SLIDES_PER_VIEW_DESKTOP_MAX = 4;
const SLIDES_TO_SCROLL = 1;
const DistinctiveProductDetails = ({ distinctiveProductDetails, }) => {
    const { imageCdnPrefix } = useAemConfig();
    const { t } = useTranslation(I18N_NAMESPACES.product);
    if (!distinctiveProductDetails.length)
        return null;
    const slidesPerViewMobile = distinctiveProductDetails.length > SLIDES_PER_VIEW_MOBILE
        ? SLIDES_PER_VIEW_MOBILE + SlideCropped.MEDIUM
        : SLIDES_PER_VIEW_MOBILE;
    const slidesPerViewTablet = distinctiveProductDetails.length > SLIDES_PER_VIEW_TABLET
        ? SLIDES_PER_VIEW_TABLET + SlideCropped.MEDIUM
        : SLIDES_PER_VIEW_TABLET;
    const slidesPerViewDesktop = distinctiveProductDetails.length > SLIDES_PER_VIEW_DESKTOP_MIN
        ? SLIDES_PER_VIEW_DESKTOP_MAX
        : SLIDES_PER_VIEW_DESKTOP_MIN;
    const sliderConfig = {
        displayCroppedSlides: false,
        hideOnViewports: false,
        infiniteSliding: false,
        innerSpacing: true,
        showArrowsForDesktop: false,
        showIndicators: false,
        slidesToScrollMobile: SLIDES_TO_SCROLL,
        slidesToScrollMobileLarge: SLIDES_TO_SCROLL,
        slidesToScrollTabletSmall: SLIDES_TO_SCROLL,
        slidesToScrollTablet: SLIDES_TO_SCROLL,
        slidesToScrollDesktop: SLIDES_TO_SCROLL,
        slidesToScrollDesktopLarge: SLIDES_TO_SCROLL,
        slidesToShowMobile: slidesPerViewMobile,
        slidesToShowMobileLarge: slidesPerViewMobile,
        slidesToShowTabletSmall: slidesPerViewTablet,
        slidesToShowTablet: slidesPerViewTablet,
        slidesToShowDesktop: slidesPerViewDesktop,
        slidesToShowDesktopLarge: slidesPerViewDesktop,
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { paddingBlockEnd: "4", children: _jsx(TextAlpha, { as: "h2", variant: "subheadingXL", testId: "distinctive-product-details-title", children: t('product.distinctive.details.title') }) }), _jsx(Slider, { fullWidth: true, properties: sliderConfig, id: "distinctive-product-details", children: distinctiveProductDetails.map(details => (_jsx("div", { style: { height: 'auto' }, children: _jsxs(Card, { fullWidth: true, children: [_jsx(Card.Media, { height: IMAGE_HEIGHT, src: details.asset.imagePath, srcset: getPictureSrcset(details.asset, imageCdnPrefix), alt: details.heading }), _jsx(Card.Header, { title: details.heading }), _jsx(Card.Body, { children: _jsx(TextAlpha, { children: details.description }) })] }) }, details.id))) })] }));
};
export default DistinctiveProductDetails;
